import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContactImage from '../components/ContactImage';
import { answerCall, attendedTransferCall, unholdCall, } from '../reducers/calls';
import styles from '../styles/call.scss';
import Tag from './Tag';
import TimeElapsed from './TimeElapsed';
import { HoldIcon, MuteIcon, TransferIcon } from './icons';
const Call = ({ id: callId }) => {
    const dispatch = useDispatch();
    const call = useSelector((state) => state.calls.find((c) => c.id === callId));
    const transferInitiated = useSelector((state) => !!state.calls.find((c) => c.transferInitiated));
    const { id, type, name, number, email, tags, started, active, ringing, direction, onHold, muted, } = call || {};
    let info;
    if (name) {
        info = (React.createElement("div", { className: styles.info },
            React.createElement("span", { className: styles.name }, name),
            React.createElement("span", { className: styles.description },
                number && React.createElement("span", { className: styles.description_text }, number),
                (tags || []).map((t, i) => (React.createElement(Tag, { key: i, className: styles.tag, label: t }))))));
    }
    else {
        info = (React.createElement("div", { className: styles.info },
            React.createElement("span", { className: styles.name }, number)));
    }
    const showTransfer = transferInitiated && !active;
    const inbound = direction === 'IN';
    let containerStyle = styles.container;
    if (ringing) {
        containerStyle = styles.container_ringing;
    }
    if (active) {
        containerStyle = styles.container_active;
    }
    let timeElapsedElement;
    if (started) {
        timeElapsedElement = React.createElement(TimeElapsed, { start: started, autoUpdate: true });
    }
    else if (inbound) {
        timeElapsedElement = React.createElement("span", { className: styles.emphasised }, "Incoming");
    }
    else {
        timeElapsedElement = '';
    }
    return (React.createElement("li", { className: containerStyle, onClick: () => {
            if (!active) {
                if (transferInitiated || !id) {
                    return;
                }
                else if (direction === 'IN' && ringing) {
                    dispatch(answerCall(id));
                }
                else {
                    dispatch(unholdCall(id));
                }
            }
        } },
        React.createElement("div", { className: styles.img },
            React.createElement(ContactImage, { email: email, type: type })),
        info,
        React.createElement("div", { className: styles.status_container },
            muted ? React.createElement(MuteIcon, { className: styles.status_icon }) : '',
            onHold ? React.createElement(HoldIcon, { className: styles.status_icon }) : ''),
        React.createElement("div", { className: styles.time_container }, timeElapsedElement),
        React.createElement("div", { className: showTransfer ? styles.slide_visible : styles.slide_hidden },
            React.createElement(TransferIcon, { className: styles.icon, onClick: () => {
                    if (!id) {
                        return;
                    }
                    dispatch(attendedTransferCall(id));
                }, title: `Transfer to ${name}` }))));
};
export default Call;
